import { submitFeedback as generatedSubmitFeedback } from '@/lib/api/generated';

import type { FeedbackSubmission, FeedbackSubmitResponse } from './ontology/types';

/** Submits authenticated feedback to the protected backend endpoint. */
export async function submitFeedback(record: FeedbackSubmission): Promise<FeedbackSubmitResponse> {
  let body: FeedbackSubmitResponse;
  try {
    body = await generatedSubmitFeedback(record);
  } catch (error: unknown) {
    const status =
      typeof error === 'object' && error !== null && 'status' in error ? Number(error.status) : 0;
    if (status > 0) {
      const message = error instanceof Error ? error.message : 'Request failed';
      throw new Error(
        message.startsWith(`HTTP ${status}`) ? message : `HTTP ${status}: ${message}`
      );
    }
    throw error;
  }

  // TODO(2): currently unreachable — backend only returns 'success'; becomes
  // meaningful once the backend reports in-body failure states (see
  // rust/server/src/api/feedback.rs SubmitFeedbackStatus).
  if (body.status !== 'success') {
    throw new Error(`Unexpected feedback submit status: ${body.status}`);
  }

  return body;
}
